export const initTabs = () => {
  const selectors = {
    buttons: '[data-tab-index]',
  }

  const elements = {
    buttons: null,
  }

  const queryElements = () => {
    elements.buttons = document.querySelectorAll(selectors.buttons)
    registerEvents()
    ;[...elements.buttons]
      .reduce((acc, item) => {
        const key = item.dataset.tabKey

        if (acc.includes(key)) return acc

        return [...acc, key]
      }, [])
      .forEach((filterKey) => {
        const buttons = [...elements.buttons].filter((el) => el.dataset.tabKey === filterKey)

        buttons[0].click()
      })
  }

  const handleButtonClick = (e) => {
    const key = e.currentTarget.dataset.tabKey
    const index = e.currentTarget.dataset.tabIndex
    const buttonsGroup = document.querySelectorAll(`[data-tab-key=${key}]`)
    const contentsGroup = document.querySelectorAll(`[data-tab-content-key=${key}]`)

    ;[...buttonsGroup].map((button) => button.classList.remove('active'))
    e.currentTarget.classList.add('active')

    if (index === '*') {
      ;[...contentsGroup].map((content) => (content.style.display = 'block'))
      return null
    }

    ;[...contentsGroup].forEach((content) => {
      const isFind = content.dataset.tabContentIndex.split(',').includes(index)

      if (isFind) {
        content.style.display = 'block'
      } else {
        content.style.display = 'none'
      }
    })
  }

  const registerEvents = () => {
    ;[...elements.buttons].map((button) => button.addEventListener('click', handleButtonClick))
  }

  queryElements()
}
